import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { FooterAppComponent } from '../../shared/components/footer-app/footer-app.component';
import { HeaderAppComponent } from 'src/app/shared/components/header-app/header-app.component';

@Component({
  selector: 'app-app-layout',
  imports: [RouterOutlet, HeaderAppComponent, FooterAppComponent],
  templateUrl: './app-layout.component.html',
})
export class AppLayoutComponent {}
